import type { CSSProperties } from "react";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";

export { Bubble };

type Props = {
  className: string;
  text: string;
  style?: CSSProperties;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

const Bubble = (props: Props) => {
  return (
    <span
      {...props.tProps}
      style={props.style}
      className={"circle " + props.className}
    >
      {props.text}
    </span>
  );
};
